import React from "react";
import { styled } from "@mui/material/styles";

import { Box, Paper, Typography, useTheme } from "@mui/material/";
import { MAPCOLORS } from "../Map/mapstyles";
import translation from "../../util/lang/acceptanceLevels";
import t__ from "../../util/lang/util";
import MapLegendModal from "./MapLegendModal";

const PREFIX = "MapLegend";

const classes = {
  mapLegend: `${PREFIX}-mapLegend`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.mapLegend}`]: {
    position: "absolute",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bottom: 30,
    left: 30,
    height: 40,
    paddingLeft: 0,
    borderRadius: 40,
    [theme.breakpoints.down("sm")]: {
      left: 20,
      width: 200,
    },
  },
}));

const MapLegend = ({ ...props }) => {
  const theme = useTheme();
  const mapColors = MAPCOLORS.default;

  return (
    <StyledPaper className={classes.mapLegend} elevation={3}>
      <Box display="flex" alignItems="center">
        <Box
          bgcolor={mapColors["J"]}
          height="12px"
          width="12px"
          borderRadius={100}
          margin={3}
        ></Box>
        <Typography variant="h5" fontWeight={500} component="div">
          {t__(theme.lang, translation, "legend.headline")}
        </Typography>
      </Box>
      <MapLegendModal />
    </StyledPaper>
  );
};

export default MapLegend;
